import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3532">
      <Navbar data-id="element-3533" />
      <main data-id="element-3534">
        <ConsularAffairs data-id="element-3535" />
      </main>
      <Footer data-id="element-3536" />
    </div>;
}